var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{on:{"click":function($event){return _vm.goTo('shipments', {}, { shipment_id: _vm.id })}}},[_vm._v("\n    "+_vm._s(_vm.id)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }